export default __webpack_public_path__ + "static/media/back-arrow.4c2db7e0.svg";